<template>
  <div class="img-wrap">
    <Card :img="getImg"
          :class="{'invalid' : !validateImg}"
          :designer="false"
          :data="data"
          :addInfo="viewData.addInfo"
          :editImg="true"
          @changeImg="changeImg"
    />
    <div class="card-block" v-if="viewData.editImg">
      <div class="img__upload">
        <span class="link" @click="onUpload">{{viewData.uploadText}}</span>
        <input class="block__link"
               type="file"
               ref="uploadFile"
               @change="changeImg"
               name="photo"
        >
      </div>
    </div>
    <div class="img-wrap align-items-start mt30 mb30 flex-grow-1"
         v-if="viewData.text !== undefined"
    >
      <div v-for="item in viewData.text"
           class="edit__text"
           :class="{'mt-auto': item.items === undefined}"
      >
        <span class="mb5">{{item.title}}</span>
        <span v-if="item.items !== undefined"
              v-for="secondItem in item.items"
              class="fw-medium fz18"
        >
          {{word(secondItem.word, data[secondItem.key])}}
        </span>
      </div>
    </div>
    <div class="edit__wrap mt30" v-if="viewData.inputs !== undefined">
      <div class="row">
        <component v-for="item in viewData.inputs"
                   :is="item.component"
                   :name="item.name"
                   :key="item.name"
                   :label="item.label"
                   :double="item.double "
                   :placeholder="item.placeholder"
                   :options="item.options"
                   :labelClass="item.labelClass"
                   v-validate="item.rules"
                   v-model="data[item.name]"
                   :error="errors.first(item.name)"
                   :class="item.className || 'col-12'"
                   @input="title"
                   :ref="item.ref"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import editMixin from '../../mixins/editMixin';
  import InputText from '../../components/inputs/InputText';
  import InputTextarea from '../../components/inputs/InputTextarea';
  import InputSelect from '../../components/inputs/InputSelect';
  import Card from "../Card";

  export default {
    name: "EditImg",
    components: {InputSelect, Card, InputText, InputTextarea},
    data() {
      return {
        data: {
          photo: '/img/photo.svg',
          name: ''
        },
        photoTouch: false
      }
    },
    methods: {
      onUpload() {
        this.$refs.uploadFile.click();
      },
      changeImg(e) {
        this.photoTouch = true;
        if (e.target.files.length > 0) {
          this.data.photo = e.target.files[0];
        }
      },
      title() {
        if (this.$route.name === 'generations-edit' || this.$route.name === 'generations-new') {
          this.data.name = '';
          if (this.data.start !== '' || this.data.end !== '') {
            this.data.name = this.data.start + '-' + this.data.end;
          }
        }
      },
      word(string, num) {
        let value = '';
        value += num + ' ';
        num = num % 10;
        if (num === 0 || num > 5) {
          value += string[0];
        }
        else if (num === 1) {
          value += string[1];
        }
        else {
          value += string[2];
        }
        return value;
      }
    },
    computed: {
      getImg() {
        if (typeof this.data.photo === "string") {
          return this.data.photo;
        }
        else if (this.data.photo === undefined) {
          return '/img/stub.webp';
        }
        else {
          return URL.createObjectURL(this.data.photo);
        }
      },
      validateImg: {
        get: function () {
          if (this.viewData.validateImg !== undefined && !this.viewData.validateImg) {
            return true;
          }
          else {
            if (this.photoTouch) {
              return this.data.photo !== '/img/photo.svg' && this.data.photo !== '';
            }
            else {
              return true;
            }
          }
        },
        set: function (v) {
          // set here
        }
      }
    },
    mixins: [editMixin]
  }
</script>

<style lang="scss">
  @import "../../style/var";

  .img {
    &-wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: -75px;
      max-width: 100%;
      .card-block {
        @media(max-width: 767px) {
          width: 180px;
        }
      }
      &--higher {
        margin-top: -125px;
      }
    }
    &__upload {
      position: relative;
      width: calc(100% + 10px);
      margin-left: -5px;
      text-align: center;
      .link {
        position: relative;
        z-index: 10;
        margin: 10px 0;
      }
    }
  }
</style>